export default __webpack_public_path__ + "static/media/0xa16eba3b7562fc92597579a80fe53a92dcab7122.9eef50b7.png";